import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const LOGS_DEBUG_URL = `${environment.basePath}/logs-debug`;

@Injectable({
  providedIn: 'root'
})
export class LogsDebugService {

  constructor(
    private _http: HttpClient,
  ) { }

  public async addLog(log: LogDebugPost): Promise<void> {
    try {
      await this._http.post(`${LOGS_DEBUG_URL}/add`, log).toPromise();
    } catch (error) {
      console.error('Error adding log:', error);
      throw error;
    }
  }
}

export interface LogDebugPost {
  content: string;
  meta?: any;
}
